class ColorFieldComponent {
  constructor($fields) {
    if (!$fields.length) return
    this.initColorFields($fields)
  }

  initColorFields($fields) {
    $fields.each((_, root) => {
      const $root = $(root)
      const $color = $root.find('.color-field__color')
      const $input = $root.find('.color-field__input')

      $color.change(() => {
        $input.val($color.val())
      })

      $input.change(() => {
        let str = $input.val().trim()

        if (str.length > 0 && str[0] !== '#') {
          str = '#' + str
        }

        if (!this.isHexColor(str)) {
          $input.val('')
          $color.val('#000000')
          return
        }

        $color.val(str)
        $input.val(str)
      })
    })
  }

  isHexColor(str) {
    return /^#[A-F0-9]{6}$/i.test(str)
  }
}

document.addEventListener('DOMContentLoaded', function () {
  return new ColorFieldComponent($('.color-field'))
})
